/**
 * URL参数解析模块.
 *
 * 负责将URL查询字符串解析为键值对格式，
 * 用于从URL参数中读取配置。
 *
 * @example
 * // 使用示例
 * const urlParams = split('?apiUrl=https://api.example.com&timeout=5000');
 * // 返回 { apiurl: 'https://api.example.com', timeout: '5000' }
 *
 * @packageDocumentation
 * @author yusangeng@outlook.com
 */
/**
 * 将url参数分割为键值对.
 *
 * @param {string} url search部分, 可以通过window.location.search取得.
 * @returns {KonphGlobal<T>} url参数表.
 * @private
 */
export default function split(searchStr) {
    if (!searchStr || searchStr === "?") {
        return {};
    }
    try {
        var segments = searchStr.replace(/^\?/, "").split("&");
        return segments
            .map(function (el) {
            var pair = el.split("=", 2);
            var key = pair[0], value = pair[1];
            if (pair.length < 2 || !key.length) {
                return void 0;
            }
            key = key.trim().toLowerCase(); // 不分大小写
            value = decodeURIComponent(value || "").trim(); // value忽略两端空格
            return { key: key, value: value };
        })
            .reduce(function (prev, el) {
            if (el) {
                prev[el.key] = el.value;
            }
            return prev;
        }, {});
    }
    catch (error) {
        console.warn("Error parsing URL parameters:", error);
        return {};
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3BsaXQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvc3BsaXQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7R0FhRztBQUlIOzs7Ozs7R0FNRztBQUNILE1BQU0sQ0FBQyxPQUFPLFVBQVUsS0FBSyxDQUMzQixTQUFpQjtJQUVqQixJQUFJLENBQUMsU0FBUyxJQUFJLFNBQVMsS0FBSyxHQUFHLEVBQUU7UUFDbkMsT0FBTyxFQUFvQixDQUFDO0tBQzdCO0lBRUQsSUFBSTtRQUNGLElBQU0sUUFBUSxHQUFHLFNBQVMsQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLEVBQUUsQ0FBQyxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztRQUV6RCxPQUFPLFFBQVE7YUFDWixHQUFHLENBQUMsVUFBQSxFQUFFO1lBQ0wsSUFBTSxJQUFJLEdBQUcsRUFBRSxDQUFDLEtBQUssQ0FBQyxHQUFHLEVBQUUsQ0FBQyxDQUFDLENBQUM7WUFDekIsSUFBQSxHQUFHLEdBQVcsSUFBSSxHQUFmLEVBQUUsS0FBSyxHQUFJLElBQUksR0FBUixDQUFTO1lBRXhCLElBQUksSUFBSSxDQUFDLE1BQU0sR0FBRyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsTUFBTSxFQUFFO2dCQUNsQyxPQUFPLEtBQUssQ0FBQyxDQUFDO2FBQ2Y7WUFFRCxHQUFHLEdBQUcsR0FBRyxDQUFDLElBQUksRUFBRSxDQUFDLFdBQVcsRUFBRSxDQUFDLENBQUMsUUFBUTtZQUN4QyxLQUFLLEdBQUcsa0JBQWtCLENBQUMsS0FBSyxJQUFJLEVBQUUsQ0FBQyxDQUFDLElBQUksRUFBRSxDQUFDLENBQUMsY0FBYztZQUU5RCxPQUFPLEVBQUUsR0FBRyxLQUFBLEVBQUUsS0FBSyxPQUFBLEVBQUUsQ0FBQztRQUN4QixDQUFDLENBQUM7YUFDRCxNQUFNLENBQUMsVUFBQyxJQUFJLEVBQUUsRUFBRTtZQUNmLElBQUksRUFBRSxFQUFFO2dCQUNOLElBQUksQ0FBQyxFQUFFLENBQUMsR0FBYyxDQUFDLEdBQUcsRUFBRSxDQUFDLEtBQVksQ0FBQzthQUMzQztZQUVELE9BQU8sSUFBSSxDQUFDO1FBQ2QsQ0FBQyxFQUFFLEVBQW9CLENBQUMsQ0FBQztLQUU1QjtJQUFDLE9BQU8sS0FBSyxFQUFFO1FBQ2QsT0FBTyxDQUFDLElBQUksQ0FBQywrQkFBK0IsRUFBRSxLQUFLLENBQUMsQ0FBQztRQUNyRCxPQUFPLEVBQW9CLENBQUM7S0FDN0I7QUFDSCxDQUFDIn0=